import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/service/auth/auth.service';
import { Permission } from 'src/app/service/common/interface';
import { LoadingService } from 'src/app/service/common/loading.service';
import { MessageService } from 'src/app/service/common/message.service';
import { SupportService } from 'src/app/service/common/support.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  private _subs : Subscription = new Subscription();
  permission : Permission = null;
  supports : any;
  supportId : any;
  supportType : any;
  supportName : any;
  constructor(
    private msgService : MessageService,
    private supportService : SupportService
  ) { 
    this.supportType = "caseTypes";
  }

  ngOnInit(): void {
    //this.permission = this.auth.getPermission();
    this.getSupports();
  }

  getSupports(){
    this._subs.add(
      this.supportService.getNames(this.supportType).subscribe(res => {
        if(res.status =='ok'){
          this.supports = res.data;
        }else{
          this.supports = null;
        }
        this.supportId = null;
        this.supportName = "";
      })
    )
  }


  editSupport(support){
    this.supportId = support.id;
    this.supportName = support.name;
  }

  saveSupportForm(){
    if(this.supportId){
      this.supportService.updateName(this.supportId, this.supportType, this.supportName).subscribe(res => {
        if(res.status == 'ok'){
          this.msgService.success(res.message);
          this.getSupports();
        }else{
          this.msgService.error(res.message);
        }
      })
    }else{
      this.supportService.saveName(this.supportType, this.supportName).subscribe(res => {
        if(res.status == 'ok'){
          this.getSupports();
          this.msgService.success(res.message);
        }else{
          this.msgService.error(res.message);
        }
      })
    }
  }
  
  clearForm(){
    this.supportId = null;
    this.supportName = "";
  }


  ngOnDestroy(){
    this._subs.unsubscribe();
  }

}
